<div
  *ngIf="page.isPreview() && !subscriptionsParams.apiUrl"
  class="no-document"
>
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Subscriptions Manage Component</strong>
    </div>
  </div>
</div>

<ng-container *ngIf="subscriptionsParams?.sectionType === 'products'">
  <ft-subscriptions-products
    [apiUrl]="subscriptionsParams.apiUrl"
  ></ft-subscriptions-products>
</ng-container>

<ng-container *ngIf="subscriptionsParams?.sectionType === 'products-v2'">
  <ft-subscriptions-products-ii
    [apiUrl]="subscriptionsParams.apiUrl"
  ></ft-subscriptions-products-ii>
</ng-container>

<ng-container *ngIf="subscriptionsParams?.sectionType === 'products-v3'">
  <ft-subscriptions-products-iii
    [apiUrl]="subscriptionsParams.apiUrl"
  ></ft-subscriptions-products-iii>
</ng-container>
